import { createBrowserHistory } from 'history';

// provides a single history instance that can be used by all components to trigger navigation without needing to return a React-router <Redirect/> element in render
export default createBrowserHistory();
